import { render, staticRenderFns } from "./LinksSquareObject.vue?vue&type=template&id=54ae299a&scoped=true&"
import script from "./LinksSquareObject.vue?vue&type=script&lang=js&"
export * from "./LinksSquareObject.vue?vue&type=script&lang=js&"
import style0 from "./LinksSquareObject.vue?vue&type=style&index=0&id=54ae299a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae299a",
  null
  
)

export default component.exports